/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".Scheduled[_ngcontent-%COMP%]{background-color:green}.Open[_ngcontent-%COMP%]{background-color:#5f9ea0}.Closed[_ngcontent-%COMP%]{background-color:red}.Rescheduled[_ngcontent-%COMP%]{background-color:blue}.Reassigned[_ngcontent-%COMP%]{background-color:#00008b}.text_appStatus[_ngcontent-%COMP%]{color:#000;font-size:medium;margin-left:2%}.color_appStatus[_ngcontent-%COMP%]{width:16px;height:16px;display:inline-grid;vertical-align:middle}.row_appStatus[_ngcontent-%COMP%]{text-align:left;margin:4px 0}body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

